import React, { Component } from 'react';
import FormTable from '../../../Fields/FormTable.js';
import FormTableSelectFilter from '../../../Fields/FormTableSelectFilter.js';
import { getTranslation } from '../../../Utilities/GetTranslation.js'
import { isEmpty, getDateString, getJsonDate, getTimeString } from '../../../Utilities/JsonFunctions.js';

declare var globalExtranet;
declare var $;

class ControlDocuments extends Component {

    getFileInfoFromRow(row) {
        let txt = "<div class=\"text-left text-nowrap\">" + (row.fileName == null ? "" : row.fileName + "<br/>") 
        let dat = getJsonDate(row.date);
        if (row.fileSize > 0) {
            txt += getTranslation("sns.general.extranet.filesize") + ": " + Math.round(row.fileSize/1024) + "Kb<br/>";
        }
        txt += getTranslation("sns.general.extranet.timestamp") + ": " + getDateString(dat) + " " + getTimeString(dat) + "<br/>";
        txt += getTranslation("sns.general.extranet.uploader") + ": "
        switch (row.creUsr) {
            case "0":
                txt += getTranslation("sns.general.extranet.uploader.candidate"); break;
            case "1":
                txt += getTranslation("sns.general.extranet.uploader.extranet"); break;
            default:
                txt += row.creUsr
        }
        switch (row.languageId) {
            case 1:
                txt += "<br/>" + getTranslation("sns.general.language") + ": " + getTranslation("custom.sns.general.nl"); break;
            case 2:
                txt += "<br/>" + getTranslation("sns.general.language") + ": " + getTranslation("custom.sns.general.fr"); break;
            case 3:
                txt += "<br/>" + getTranslation("sns.general.language") + ": " + getTranslation("custom.sns.general.en"); break;
            default: break;
        }

        return txt + "</div>";
    }

    render() {
        var columns = [
            {
                Header: "",
                accessor: "historyId",
                maxWidth: 50,
                filterable: false,
                Cell: row => (
                    <div>
                        {
                            isEmpty(row.row._original.uploadId) ?
                                <a className="subcatlink" href={globalExtranet.extranetMsgUrl + "?id=" + row.row._original.msgId} target="_blank">
                                    <i className="fa fa-search" aria-hidden="true"></i>
                                </a> :
                                <a className="subcatlink" href={globalExtranet.extranetDocumentsUrl + "?id=" + row.row._original.uploadId} target="_blank">
                                    <i className="fa fa-search" aria-hidden="true"></i>
                                </a>
                        }
                    </div>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.documentlabel"),
                accessor: "documentLabel",
                minWidth: 300,
                Filter: ({filter, onChange}) => {
                    return (<FormTableSelectFilter filter={filter} onChange={onChange} data={this.props.documents} accessor="documentLabel" />);
                } 
            },
            {
                Header: getTranslation("sns.general.extranet.documenttype"),
                accessor: "documentType",
                minWidth: 150,
                filterMethod: (filter, row) => {
                    switch(filter.value) {
                        case "project":
                            return (row.personName == null && row.personFirstName == null);
                        case "candidate":
                            return !(row.personName == null && row.personFirstName == null);
                        default: return true;
                    }
                },
                Filter: ({filter, onChange}) => {
                    return (
                        <div className="select-wrapper">
                            <select
                                onChange={event => onChange(event.target.value)}
                                value={filter ? filter.value : "all"}>
                                <option value=""></option>
                                <option value="project">{getTranslation("sns.project.extranet.documenttype.project")}</option>
                                <option value="candidate">{getTranslation("sns.project.extranet.documenttype.candidate")}</option>
                            </select>
                        </div>
                    );
                },
                show: this.props.showDocumentType === true,
                Cell: row => (
                    (row.row.personName == null && row.row.personFirstName == null) ?
                        <span>
                            {getTranslation("sns.project.extranet.documenttype.project")}
                        </span> :
                        <span>
                            {getTranslation("sns.project.extranet.documenttype.candidate")}
                        </span>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.candidatename"),
                accessor: "personName",
                minWidth: 150,
                show: this.props.onNavigateToCandidates != null,
                Cell: row => (
                    <span>
                        {
                            row.value != null ?
                                <a onClick={(e) => this.props.onNavigateToCandidates(row.row._original)}>{row.value}</a> : ""
                        }
                    </span>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.candidatefirstname"),
                accessor: "personFirstName",
                minWidth: 150,
                show: this.props.onNavigateToCandidates != null,
                Cell: row => (
                    <span>
                        {
                            row.value != null ?
                                <a onClick={(e) => this.props.onNavigateToCandidates(row.row._original)}>{row.value}</a> : ""
                        }
                    </span>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.project"),
                accessor: "project",
                minWidth: 300,
                show: this.props.onNavigateToProjects != null,
                Cell: row => (
                    <span>
                        {
                            row.value != null ?
                                <a title={row.value} onClick={(e) => this.props.onNavigateToProjects(row.row._original)}>{row.value}</a> : ""
                        }
                    </span>
                ),                
                Filter: ({filter, onChange}) => {
                    return (<FormTableSelectFilter filter={filter} onChange={onChange} data={this.props.documents} accessor="project" />);
                },
                filterMethod: (filter, row) => {
                    const id = filter.pivotId || filter.id;
                    if (row[id] !== null) {
                        if(row[id] === undefined)
                            return true;
                        
                        return  row[id].toString().toLowerCase() === filter.value.toString().toLowerCase();
                    }
                } 
            },
            {
                Header: getTranslation("sns.general.extranet.entrydate"),
                accessor: "date",
                width: 125,
                filterable: false,
                Cell: row => {
                    return <span>{getDateString(getJsonDate(row.value))}</span>
                }
            },
            {
                Header: "",
                accessor: "docInfo",
                filterable: false,
                width: 50,
                Cell: row => {
                    return (
                        <div id={"docInfo" + row.row._original.historyId} data-html="true" data-placement="left" data-toggle="tooltip" className="position-relative" title={this.getFileInfoFromRow(row.row._original)}>
                            <i className="fa fa-info-circle" aria-hidden="true"></i>
                        </div>
                    )
                }
            }
        ]

        return (
            <FormTable 
                data={
                    this.props.documents                                        
                }
                columns={columns}
                filterable={true}
                defaultFiltered={[{id:"documentType", value: this.props.filterDocumentType}]}
                defaultSorted={[{id:"date", desc: true}]}
                />                                
        );
    }
}

export default ControlDocuments;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ControlDocuments.js